import { SystemsContext } from '../context/SystemContext'
import { useContext } from 'react'

export const useSystemsContext = () => {
  const context = useContext(SystemsContext)

  if (!context) {
    throw Error('useSystemsContext must be used inside an SystemsContextProvider')
  }

  return context
}